import React, { useEffect, useRef, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { toast } from "react-toastify";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import { Grid, LinearProgress, Typography, Box, Button } from "@material-ui/core";
import api from "../../services/api";
import { has, get, isNull } from "lodash";
import GroupIcon from "@material-ui/icons/Group";
import ScheduleIcon from "@material-ui/icons/Schedule";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import DoneIcon from "@material-ui/icons/Done";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import ListAltIcon from "@material-ui/icons/ListAlt";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import AssessmentOutlinedIcon from "@material-ui/icons/AssessmentOutlined";
import { useDate } from "../../hooks/useDate";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";

// import { SocketContext } from "../../context/Socket/SocketContext";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  pageRoot: {
    flex: 1,
    width: "100%",
    maxWidth: "100%",
    padding: theme.spacing(2),
    height: "calc(100% - 48px)",
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
      height: "auto",
      minHeight: "calc(100vh - 48px)",
      overflowY: "auto",
    },
  },
  mainPaper: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    margin: 0,
    padding: theme.spacing(3),
    ...theme.scrollbarStyles,
    background: "linear-gradient(180deg, #f8fbff 0%, #ffffff 100%)",
    borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 12px 26px rgba(17, 24, 39, 0.09)",
  },
  topBanner: {
    padding: theme.spacing(2.5),
    borderRadius: 14,
    background:
      "linear-gradient(135deg, rgba(6,81,131,0.1) 0%, rgba(40,167,69,0.08) 100%)",
    border: "1px solid rgba(6,81,131,0.16)",
    marginBottom: theme.spacing(2),
  },
  topBannerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    flexWrap: "wrap",
  },
  topBannerTitle: {
    fontWeight: 700,
    color: "#1f2a37",
  },
  topBannerSub: {
    marginTop: theme.spacing(0.5),
    color: "#5b6472",
  },
  progressWrap: {
    marginTop: theme.spacing(2),
  },
  progressBar: {
    height: 14,
    borderRadius: 999,
    backgroundColor: "#eaf0f6",
  },
  statsGrid: {
    marginTop: theme.spacing(1),
  },
  statsGridItem: {
    display: "flex",
  },
  statCard: {
    borderRadius: 14,
    border: "1px solid #e6edf5",
    backgroundColor: "#fff",
    padding: theme.spacing(2),
    minHeight: 112,
    width: "100%",
    display: "flex",
    gap: theme.spacing(1.5),
    alignItems: "center",
    boxShadow: "0 5px 18px rgba(15,23,42,0.04)",
  },
  statIcon: {
    width: 42,
    height: 42,
    borderRadius: 10,
    display: "grid",
    placeItems: "center",
    color: "#065183",
    backgroundColor: "rgba(6,81,131,0.10)",
    flexShrink: 0,
  },
  statLabel: {
    fontSize: 13,
    color: "#697586",
  },
  statValue: {
    fontSize: 22,
    fontWeight: 700,
    color: "#111827",
    lineHeight: 1.1,
  },
  statValueText: {
    fontSize: 15,
    fontWeight: 600,
    color: "#111827",
  },
  downloadButton: {
    position: "fixed",
    right: theme.spacing(5),
    bottom: theme.spacing(3),
    zIndex: 1200,
    borderRadius: 10,
    padding: theme.spacing(1, 2),
    color: "#fff",
    backgroundColor: theme.palette.primary.main,
    textTransform: "none",
    fontWeight: 600,
    boxShadow: "0 12px 24px rgba(6,81,131,0.35)",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark || theme.palette.primary.main,
    },
  },
}));

const CampaignReport = () => {
  const classes = useStyles();
  const history = useHistory();

  const { campaignId } = useParams();

  const [campaign, setCampaign] = useState({});
  const [validContacts, setValidContacts] = useState(0);
  const [delivered, setDelivered] = useState(0);
  const [confirmationRequested, setConfirmationRequested] = useState(0);
  const [confirmed, setConfirmed] = useState(0);
  const [percent, setPercent] = useState(0);
  const [loading, setLoading] = useState(false);
  const [notDeliveredContacts, setNotDeliveredContacts] = useState([]);
  const mounted = useRef(true);
  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);


  const { datetimeToClient } = useDate();
  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);
      if (!planConfigs.plan.useCampaigns) {
        toast.error("Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.");
        setTimeout(() => {
          history.push(`/`)
        }, 1000);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (mounted.current) {
      findCampaign();
    }

    return () => {
      mounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (mounted.current && has(campaign, "shipping")) {
      if (has(campaign, "contactList")) {
        const contactList = get(campaign, "contactList");
        const valids = contactList.contacts.filter((c) => c.isWhatsappValid);
        setValidContacts(valids.length);
      }

      if (has(campaign, "shipping")) {
        const contacts = get(campaign, "shipping");
        const delivered = contacts.filter((c) => !isNull(c.deliveredAt));
        const confirmationRequested = contacts.filter(
          (c) => !isNull(c.confirmationRequestedAt)
        );
        const confirmed = contacts.filter(
          (c) => !isNull(c.deliveredAt) && !isNull(c.confirmationRequestedAt)
        );
        setDelivered(delivered.length);
        setConfirmationRequested(confirmationRequested.length);
        setConfirmed(confirmed.length);
        setDelivered(delivered.length);
      }

      const contactList = get(campaign, "contactList.contacts", []);
      const shipping = get(campaign, "shipping", []);
      const deliveredIds = new Set(
        shipping
          .filter((item) => !isNull(item.deliveredAt))
          .map((item) => item.contactId)
      );
      const pending = contactList.filter(
        (contact) => contact.isWhatsappValid && !deliveredIds.has(contact.id)
      );
      setNotDeliveredContacts(pending);
    }
  }, [campaign]);

  useEffect(() => {
    if (!validContacts) {
      setPercent(0);
      return;
    }
    setPercent((delivered / validContacts) * 100);
  }, [delivered, validContacts]);

  useEffect(() => {
    const companyId = user.companyId;
    // const socket = socketManager.GetSocket();

    const onCampaignEvent = (data) => {

      if (data.record.id === +campaignId) {
        setCampaign(data.record);

        if (data.record.status === "FINALIZADA") {
          setTimeout(() => {
            findCampaign();
          }, 5000);
        }
      }
    };
    socket.on(`company-${companyId}-campaign`, onCampaignEvent);

    return () => {
      socket.off(`company-${companyId}-campaign`, onCampaignEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignId]);

  const findCampaign = async () => {
    setLoading(true);
    const { data } = await api.get(`/campaigns/${campaignId}`);
    setCampaign(data);
    setLoading(false);
  };

  const formatStatus = (val) => {
    switch (val) {
      case "INATIVA":
        return i18n.t("campaignReport.inactive");
      case "PROGRAMADA":
        return i18n.t("campaignReport.scheduled");
      case "EM_ANDAMENTO":
        return i18n.t("campaignReport.process");
      case "CANCELADA":
        return i18n.t("campaignReport.cancelled");
      case "FINALIZADA":
        return i18n.t("campaignReport.finished");
      default:
        return val;
    }
  };

  const downloadNotDeliveredCsv = () => {
    if (!notDeliveredContacts.length) {
      toast.info("Não há contatos pendentes para exportar.");
      return;
    }

    const lines = [
      ["nome", "numero", "e-mail"],
      ...notDeliveredContacts.map((c) => [c.name || "", c.number || "", c.email || ""])
    ];
    const csv = lines
      .map((row) =>
        row
          .map((value) => `"${String(value).replace(/"/g, '""')}"`)
          .join(";")
      )
      .join("\n");

    const csvWithBom = `\uFEFF${csv}`;
    const blob = new Blob([csvWithBom], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `campanha-${campaignId}-nao-enviados-${new Date().toISOString().slice(0, 10)}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const StatusCard = ({ icon, title, value, isText }) => (
    <Paper className={classes.statCard} elevation={0}>
      <Box className={classes.statIcon}>{icon}</Box>
      <Box>
        <Typography className={classes.statLabel}>{title}</Typography>
        <Typography className={isText ? classes.statValueText : classes.statValue}>
          {loading ? "..." : value}
        </Typography>
      </Box>
    </Paper>
  );

  return (
    <div className={classes.pageRoot}>
      <MainHeader>
        <Grid style={{ width: "100%", margin: 0 }} container>
          <Grid xs={12} item>
            <Title>{i18n.t("campaignReport.title")} {campaign.name || i18n.t("campaignReport.campaign")}</Title>
          </Grid>
        </Grid>
      </MainHeader>
      <Paper className={classes.mainPaper} variant="outlined">
        <Box className={classes.topBanner}>
          <Box className={classes.topBannerHeader}>
            <Box display="flex" alignItems="center" gridGap={10}>
              <AssessmentOutlinedIcon style={{ color: "#065183", fontSize: 28 }} />
              <Typography variant="h6" className={classes.topBannerTitle}>
                Status: {formatStatus(campaign.status)} | {delivered} de {validContacts}
              </Typography>
            </Box>
          </Box>
          <Typography variant="body2" className={classes.topBannerSub}>
            Acompanhe o progresso em tempo real e exporte os contatos pendentes para continuar o envio em uma nova campanha.
          </Typography>
          <Box className={classes.progressWrap}>
            <LinearProgress
              variant="determinate"
              className={classes.progressBar}
              value={percent}
            />
          </Box>
        </Box>

        <Grid spacing={2} container className={classes.statsGrid}>
          <Grid xs={12} sm={6} md={4} lg={3} item className={classes.statsGridItem}>
            <StatusCard
              icon={<GroupIcon fontSize="small" />}
              title={i18n.t("campaignReport.validContacts")}
              value={validContacts}
            />
          </Grid>
          <Grid xs={12} sm={6} md={4} lg={3} item className={classes.statsGridItem}>
            <StatusCard
              icon={<CheckCircleIcon fontSize="small" />}
              title={i18n.t("campaignReport.deliver")}
              value={delivered}
            />
          </Grid>
          {campaign.confirmation && (
            <>
              <Grid xs={12} sm={6} md={4} lg={3} item className={classes.statsGridItem}>
                <StatusCard
                  icon={<DoneIcon fontSize="small" />}
                  title={i18n.t("campaignReport.confirmationsRequested")}
                  value={confirmationRequested}
                />
              </Grid>
              <Grid xs={12} sm={6} md={4} lg={3} item className={classes.statsGridItem}>
                <StatusCard
                  icon={<DoneAllIcon fontSize="small" />}
                  title={i18n.t("campaignReport.confirmations")}
                  value={confirmed}
                />
              </Grid>
            </>
          )}
          <Grid xs={12} sm={6} md={4} lg={3} item className={classes.statsGridItem}>
            <StatusCard
              icon={<ErrorOutlineIcon fontSize="small" />}
              title="Não enviados"
              value={notDeliveredContacts.length}
            />
          </Grid>
          {campaign.whatsappId && (
            <Grid xs={12} sm={6} md={4} lg={3} item className={classes.statsGridItem}>
              <StatusCard
                icon={<WhatsAppIcon fontSize="small" />}
                title={i18n.t("campaignReport.connection")}
                value={get(campaign, "whatsapp.name", "-")}
                isText
              />
            </Grid>
          )}
          {campaign.contactListId && (
            <Grid xs={12} sm={6} md={4} lg={3} item className={classes.statsGridItem}>
              <StatusCard
                icon={<ListAltIcon fontSize="small" />}
                title={i18n.t("campaignReport.contactLists")}
                value={get(campaign, "contactList.name", "-")}
                isText
              />
            </Grid>
          )}
          <Grid xs={12} sm={6} md={4} lg={3} item className={classes.statsGridItem}>
            <StatusCard
              icon={<ScheduleIcon fontSize="small" />}
              title={i18n.t("campaignReport.schedule")}
              value={datetimeToClient(campaign.scheduledAt)}
              isText
            />
          </Grid>
          <Grid xs={12} sm={6} md={4} lg={3} item className={classes.statsGridItem}>
            <StatusCard
              icon={<EventAvailableIcon fontSize="small" />}
              title={i18n.t("campaignReport.conclusion")}
              value={datetimeToClient(campaign.completedAt)}
              isText
            />
          </Grid>
        </Grid>

      </Paper>
      <Button
        className={classes.downloadButton}
        startIcon={<CloudDownloadIcon />}
        variant="contained"
        onClick={downloadNotDeliveredCsv}
      >
        Baixar não enviados
      </Button>
    </div>
  );
};

export default CampaignReport;
